/* eslint-disable prefer-rest-params */
import { AxiosResponse } from 'axios';
import { API_ROUTES } from '../../../constants/app';
import { Command } from '../../../types/commands';
import axios, { handleUnauthorized } from '../../axios';
import { FigmaWidgetSettings } from '../../../types';

export async function addNewFigmaWidgetToSectionApi({
  guideId,
  chapterId,
  pageId,
  sectionId,
  widgetId,
  columnIndex,
  guideVersion,
  figmaWidgetPayload,
}: {
  guideId: string;
  chapterId: string;
  pageId: string;
  sectionId: string;
  widgetId: string;
  columnIndex: number;
  guideVersion: number;
  figmaWidgetPayload: {
    settings: {
      theme: 'light' | 'dark' | 'system';
      footer: boolean;
      controls: boolean;
    };
  };
}): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.ADD_NEW_FIGMA_WIDGET_TO_SECTION,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        figmaWidgetPayload,
      },
    })
    .catch(error =>
      handleUnauthorized(error, addNewFigmaWidgetToSectionApi, ...arguments),
    );
}
export async function editFigmaWidgetSourceApi({
  guideId,
  chapterId,
  pageId,
  sectionId,
  widgetId,
  columnIndex,
  guideVersion,
  source,
}: {
  guideId: string;
  chapterId: string;
  pageId: string;
  sectionId: string;
  widgetId: string;
  columnIndex: number;
  guideVersion: number;
  source: string;
}): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_SOURCE_IN_FIGMA_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        figmaWidgetPayload: {
          sourceId: source,
        },
      },
    })
    .catch(error =>
      handleUnauthorized(error, editFigmaWidgetSourceApi, ...arguments),
    );
}
export async function editFigmaWidgetPropertiesApi({
  guideId,
  chapterId,
  pageId,
  sectionId,
  widgetId,
  columnIndex,
  guideVersion,
  settings,
}: {
  guideId: string;
  chapterId: string;
  pageId: string;
  sectionId: string;
  widgetId: string;
  columnIndex: number;
  guideVersion: number;
  settings: FigmaWidgetSettings;
}): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_SETTINGS_IN_FIGMA_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        figmaWidgetPayload: {
          settings,
        },
      },
    })
    .catch(error =>
      handleUnauthorized(error, editFigmaWidgetPropertiesApi, ...arguments),
    );
}
